import React from 'react';
import { FolderOpen } from 'lucide-react';

export const SavedPacks = ({ packs, onOpen, activeId }) => (
  <section className="bg-white dark:bg-[#0F1115] border border-black/[0.08] dark:border-white/5 rounded-2xl p-5" data-testid="creator-ideation-saved-packs">
    <div className="text-xs font-semibold uppercase tracking-[0.08em] text-[#0F0F0F] dark:text-white mb-3 flex items-center gap-1.5"><FolderOpen size={13} /> Saved Packs</div>
    {packs.length === 0 ? <p className="text-xs text-[#6B6B6B] dark:text-zinc-400" data-testid="creator-ideation-saved-packs-empty">No saved packs yet. Generate ideas and hit Save Pack.</p> : (
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-2 max-h-72 overflow-y-auto">
        {packs.map((p) => (
          <button key={p.id} onClick={() => onOpen(p.id)} className={`text-left rounded-lg px-3 py-2 border transition-colors ${activeId === p.id ? 'border-[#FF451A] bg-[#FF451A]/[0.05]' : 'border-black/[0.06] dark:border-white/5 hover:border-[#FF451A]/40'}`} data-testid={`creator-ideation-pack-${p.id}`}>
            <div className="text-sm font-medium text-[#0F0F0F] dark:text-white truncate">{p.creator_name || 'No creator'} · {(p.niches || []).join(' + ')}</div>
            <div className="text-[11px] text-[#6B6B6B] dark:text-zinc-400">{p.idea_count} ideas · {p.format} · {p.language} · {new Date(p.generated_at).toLocaleDateString()}{p.saved_by_name ? ` · ${p.saved_by_name}` : ''}</div>
          </button>
        ))}
      </div>
    )}
  </section>
);
